exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span {\n  display: inline-block;\n  margin: 0.4ex;\n  margin-right: 1ex;\n  padding: 0.5em;\n  padding-top: 0.5ex;\n  padding-bottom: 0.5ex;\n  border: thin solid silver;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: small\n}\n\nspan.selected {\n  background-color: #F5F583\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/tag-page/tag-page.component.css
// module id = ../../../../../src/app/tag-page/tag-page.component.css
// module chunks = main